function reveal(){
  window.sr = ScrollReveal({ duration: 2000, scale: 1 });
  var arr = ['hr.left', 'hr.right','hr.hr--very-small', 'hr.hr--small', 'h1','h2','h3','h4','p','img.img--fullwidth','img.img-responsive', 'img.img--small','img.img--medium', 'li','.col--cadre']
  for (el of arr) {
    sr.reveal(el)
  }
}

module.exports = function () {
  // reveal()
  track()
}

function track(){
  $(".track").on("click",function(){
    var what = $(this).data("what");
    // console.log(what);
    _paq.push(['trackEvent', 'Button', 'Click', what]);

  })
}



//////////////////
// WEBPACK FOOTER
// ./app/shared/js/main.js
// module id = 13
// module chunks = 0 1 2 3 4 5 6 7 8